module.exports = __webpack_public_path__ + "static/media/background5.94bf4f1d.png";